export const buildFaqSchema = (items = []) => {
  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }

  const mainEntity = items
    .map((item) => ({
      pregunta: item?.pregunta,
      respuesta: item?.respuesta,
    }))
    .filter((item) => item.pregunta && item.respuesta)
    .map((item) => ({
      "@type": "Question",
      name: item.pregunta,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.respuesta,
      },
    }));

  if (mainEntity.length === 0) {
    return null;
  }

  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity,
  };
};

// Datos estructurados de un evento online (webinar) para resultados enriquecidos
// de Google. Devuelve null si faltan datos mínimos (name/startDate/url), así que
// no se publica nada hasta que el evento esté configurado de verdad.
export const buildEventSchema = ({
  name,
  description,
  startDate,
  endDate,
  url,
  image,
  locationUrl,
} = {}) => {
  if (!name || !startDate || !url) {
    return null;
  }

  return {
    "@context": "https://schema.org",
    "@type": "Event",
    name,
    description: description || undefined,
    startDate,
    endDate: endDate || undefined,
    eventAttendanceMode: "https://schema.org/OnlineEventAttendanceMode",
    eventStatus: "https://schema.org/EventScheduled",
    location: {
      "@type": "VirtualLocation",
      url: locationUrl || url,
    },
    image: image ? [image] : undefined,
    organizer: {
      "@type": "Organization",
      name: "InvokeApp",
      url: "https://invokeapp.io",
    },
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "EUR",
      availability: "https://schema.org/InStock",
      url,
    },
  };
};

